import type { Feature } from './types';

import { getEnvValue } from '../utils';

interface BirdGameFeaturePayload extends Record<string, unknown> {
  readonly serviceUrl: string;
}

function getServiceUrl(): string | undefined {
  const rawValue = getEnvValue('NEXT_PUBLIC_BIRD_GAME_URL')?.trim();
  if (!rawValue) {
    return undefined;
  }

  try {
    const url = new URL(rawValue);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return undefined;
    }

    return url.toString().replace(/\/$/, '');
  } catch (_error) {
    return undefined;
  }
}

const title = 'Explorer Bird game';
const serviceUrl = getServiceUrl();

export const birdGame: Feature<BirdGameFeaturePayload> = serviceUrl ? Object.freeze({
  title,
  isEnabled: true,
  serviceUrl,
}) : Object.freeze({
  title,
  isEnabled: false,
});
